import { isTelegram } from './telegram';
import { jsonHeadersWithAuth } from '../utils/webAuth';

const API_BASE =
  import.meta.env.VITE_API_URL || 'https://verbum-api-production.up.railway.app/api';

export const BOT_USERNAME = 'VerbumBibleBot';

/** Бот не может писать человеку (не запускал или заблокировал) — дальше в этой сессии открываем панели. */
const UNREACHABLE_KEY = 'verbum.botChatUnreachable';

/** В Telegram-приложении ответы на кнопки стиха приходят в чат с ботом, а не в панели. */
export function answersGoToBotChat() {
  if (!isTelegram()) return false;
  if (typeof window.Telegram?.WebApp?.openTelegramLink !== 'function') return false;
  try {
    return sessionStorage.getItem(UNREACHABLE_KEY) !== '1';
  } catch {
    return true;
  }
}

/**
 * Просит бота прислать вкладку толкования (или карточку «Спросить», tab = 'ask') в личный чат.
 * @returns {Promise<{ ok: true } | { ok: false, reason: 'unreachable' | 'limit' | 'error', payload?: object }>}
 */
export async function sendVerseStudyToBot({ bookId, chapter, verse, tab, translation }) {
  try {
    const res = await fetch(`${API_BASE}/telegram/verse-study`, {
      method: 'POST',
      headers: jsonHeadersWithAuth({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        bookId: parseInt(bookId, 10),
        chapter: parseInt(chapter, 10),
        verse: parseInt(verse, 10),
        tab,
        language: localStorage.getItem('bibleLanguage') || 'ru',
        translation,
      }),
    });
    if (res.ok) return { ok: true };
    const payload = await res.json().catch(() => null);
    if (res.status === 409) {
      try {
        sessionStorage.setItem(UNREACHABLE_KEY, '1');
      } catch {
        /* приватный режим */
      }
      return { ok: false, reason: 'unreachable' };
    }
    if (res.status === 429) return { ok: false, reason: 'limit', payload };
    return { ok: false, reason: 'error' };
  } catch {
    return { ok: false, reason: 'error' };
  }
}

/**
 * Уводит в чат с ботом: открывает чат и закрывает приложение, чтобы ответ было видно сразу.
 * Вернуться к тому же стиху — кнопкой «Назад к чтению» под ответом.
 */
export function openBotChat() {
  const webApp = window.Telegram?.WebApp;
  try {
    webApp?.openTelegramLink?.(`https://t.me/${BOT_USERNAME}`);
  } catch {
    /* старый клиент */
  }
  window.setTimeout(() => {
    try {
      webApp?.close?.();
    } catch {
      /* уже закрыто */
    }
  }, 350);
}
